<template>
  <b-modal class="modal-lg" size="lg" id="menuBuilderInstructions" title='Menu Builder Instructions' :header-bg-variant="'secondary'" hide-backdrop okVariant="secondary" ok-only @hide="hideModal()">
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title text-light">
        Menu Builder Instructions
      </h5>
      <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">X</span></button>
    </template>
    <template slot="default">
      <div class="row mx-0 p-1">
        <h4>Basics</h4>
        <span class="mb-3">
          This page can be used to create/update/delete navigation links. You can start doing so by selecting the user level for which you want to edit the navbar.
        </span>
        <li class="inst-li">
          After selecting user level you will see two boxes, "<span class="text-primary font-weight-bold">Active</span>" and "<span class="text-danger font-weight-bold">Inactive</span>". They represent <b class="text-danger">parent</b> navigations which are the highest level navigations ( the ones you see on the navigation ).
        </li>
        <li class="inst-li">
          You can drag and drop every link in here, putting it in "<span class="text-danger font-weight-bold">Inactive</span>" box will make it invisible to currently selected user level while "<span class="text-primary font-weight-bold">Active</span>" box will do the opposite.
        </li>
        <li class="inst-li">
          Clicking on the "X" will bring up a modal to delete the currently selected <b class="text-danger">parent</b> link ( make sure that link has no children in it beforehand! ). More information can be found under "Create new parent link" button.
        </li>
        <hr class="line">
        <h4>Editing Sub-navigation</h4>
        <li class="inst-li">
          Clicking on one of the <b class="text-danger">parent</b> buttons will open a new box containing all the sub-navigation for that <b class="text-danger">parent</b>.
        </li>
        <li class="inst-li">
          You may have 2 <b class="text-danger">parent</b> navigations open at the same time ( currently selected buttons will change color to <span class="text-success">green</span> ). That can be used to transfer sub-navigations between the currently selected parents by drag and dropping.
        </li>
        <li class="inst-li">
          Clicking on the sub-navigation link will toggle it's state between <span class="text-primary font-weight-bold">Active</span> and <span class="text-danger font-weight-bold">Inactive</span>.
        </li>
        <li class="inst-li">
          The links can be drag and dropped between each other and between each visible column, doing so will change their order.
        </li>
        <li class="inst-li">
          After doing all the changes make sure you click on <button class="btn btn-primary" type="button">Save Navigation</button> button in the box that was edited.
        </li>
        <hr class="line">
        <h4>Creating New Link</h4>
        <li class="inst-li">
          If you want to create a new link make sure the <b class="text-danger">parent</b> navigation is already selected. If it is you can click on <button class="btn btn-primary" type="button">Create Link</button> button to start the link creation process.
        </li>
        <li class="inst-li text-danger font-weight-bold">
          You can create link only if it already exists in any other place/portal! Otherwise created link will NOT work!
        </li>
        <li class="inst-li">
          Link URL is the last part of the URL the user can see ( example: reporting/view_logs where "reporting" is the <b class="text-danger">parent</b> and "view_logs" is the <b class="text-success">sub-navigation</b>, the one we need to use so in our case the URL will be only <b>"view_logs"</b>)
        </li>
        <li class="inst-li">
          Link Translation is translation key that will be used for it.
        </li>
        <li class="inst-li">
          Link Column/Position are responsible for positioning the link in <b class="text-success">sub-navigation</b>.
        </li>
        <hr class="line">
        <h4>Importing/Moving navigation between user levels</h4>
        <li class="inst-li">
          If you need to add/transfer <b class="text-success">sub-navigation</b> from another user level you can do so by clicking the <button class="btn btn-secondary" type="button">Import Link</button> button inside a <b class="text-success">sub-navigation</b> box.
        </li>
        <li class="inst-li">
          After clicking on the button a new box will appear <b>ABOVE</b> the <b class="text-success">sub-navigation</b> box. It will be titled "Import Links". We have to select the user level from which we want to import the navigation.
        </li>
        <li class="inst-li">
          A list of <b class="text-danger">parent</b> navigations should appear, next step is selecting from which <b class="text-danger">parent</b> we want to import the link.
        </li>
        <li class="inst-li">
          Once user level and <b class="text-danger">parent</b> has been selected a new box should appear <b>BELOW</b> the "Import Links" box ( between Import links and the currently active <b class="text-success">sub-navigation</b> ).
        </li>
        <li class="inst-li">
          To import link from a different user level all we have to do now is drag and drop link <b>FROM</b> the Import box to <b class="text-success">sub-navigation</b> that we openened at the very beginning.
        </li>
        <li class="inst-li text-danger">
          After doing all this make sure the <button class="btn btn-primary" type="button">Save Navigation</button> is clicked inside the box that we imported links to!!!
        </li>
        <hr class="line">
      </div>
    </template>
    <template slot="modal-footer" slot-scope="{ cancel }">
      <button aria-label="Cancel" data-dismiss="modal" class="btn btn-secondary" type="button" @click="cancel()">
        <fontAwesomeIcon :icon="['fa', 'ban']" class="text-light mr-2"/>Close
      </button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'NewParentNavigationModal',
  data() {
    return {
      isBusy: false
    }
  },
  methods: {
    hideModal() {
      this.$parent.disableOverlay()
    },
  }
}
</script>

<style scoped>
  .line {
    border: 0px;
    margin: 5px 0px 5px 0px;
    height: 1px;
    background-color: rgba(83, 101, 140, 0.33);
    width: 100%;
  }
  .inst-li {
    margin-bottom: 10px;
  }
</style>